import ThemeProvider from './context/ThemeProvider';
import './App.css';
import {BrowserRouter as Router, Routes ,Route} from 'react-router-dom';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import Home from './pages/Home';
import Footer from './components/Footer';
import DashBoard from './Dashboard/DashBoard';
import CustomerList from './Dashboard/CustomerList';
import Carlists from './Dashboard/Carlists';
import AllBookings from './Dashboard/AllBookings';
import TodayBookings from './Dashboard/TodayBookings';
import DriverList from './Dashboard/DriverList';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import AdminPage from './Dashboard/AdminPage';
import Profile from './components/Profile';
import MyBooks from './components/MyBooks';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './Dashboard/components/AdminProtectedRoute';
import Settings from './pages/Settings';
function App() {

  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");

  return (
    <ThemeProvider>
      <div className="app-container">
        <Router>
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/SignUp" element={<SignUp />} />
              <Route path="/Home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/Profile" element={<Profile/>} />

              <Route path="/Admin" element={<AdminPage />}/>
              <Route path="/DashBoard" element={<AdminProtectedRoute><DashBoard /></AdminProtectedRoute>}/>
              <Route path="/CustomerList" element={<CustomerList />} />
              <Route path="/Carlists" element={<Carlists />} />
              <Route path="/DriverList" element={<DriverList />} />
              <Route path="/AllBookings" element={<AllBookings />} />
              <Route path="/TodayBookings" element={<TodayBookings />} />   
              <Route path="/MyBooks" element={<MyBooks userId={userId} token={token} />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </div>
          <Footer />
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
